import React from 'react';

/**
 * Wraps a page section with consistent vertical rhythm + max width.
 * Brief: max-w 1120px, 80px desktop / 48px mobile vertical padding.
 */
export default function Section({
  children,
  bg = 'transparent',
  className = '',
  innerClassName = '',
  id,
  testId,
}) {
  const bgClass = {
    bg: 'bg-[#F6F8FB]',
    white: 'bg-white',
    card: 'bg-white',
    soft: 'bg-[#D9FBEA]/20',
    cream: 'bg-[#FDFCF9]',
    navy: 'bg-[#1E2A44] text-white',
    dark: 'bg-[#0B0E1A] text-white overflow-hidden',
    transparent: '',
  }[bg] || '';

  return (
    <section id={id} className={`${bgClass} ${className}`} data-testid={testId}>
      <div className={`max-w-[1120px] mx-auto px-5 sm:px-6 lg:px-8 py-12 sm:py-20 ${innerClassName}`}>
        {children}
      </div>
    </section>
  );
}
